import { useSyncExternalStore } from 'react';
import {
  currentDesktopWindowState,
  subscribeDesktopWindowState,
  type DesktopWindowState,
} from '../lib/desktop';

/** React view of the desktop window state; in a browser, always focused and visible. */
export function useDesktopWindowState(): DesktopWindowState {
  return useSyncExternalStore(
    subscribeDesktopWindowState,
    currentDesktopWindowState,
    currentDesktopWindowState,
  );
}
